import { useState } from "react";
import Skill from "./Skill";
import { backend_Skills, frontend_Skills } from "./skillsData";
import "./skillsUpdatedUi.css";

const SkillsUpdatedUi = () => {
  const [closeDetailsOne, setCloseDetailsOne] = useState(false);
  const [closeDetailsTwo, setCloseDetailsTwo] = useState(false);

  const toggleSkills = (val) => {
    if (val === 1) {
      setCloseDetailsOne(!closeDetailsOne);
    } else if (val === 2) {
      setCloseDetailsTwo(!closeDetailsTwo);
    }
  };

  return (
    <section className="skills_section" id="skills">
      <h2 className="section__title"> Skills </h2>
      <span className="section__subtitle">My Technical Skill Set</span>
      <div className="skills_container container grid">
        <div>
          <div
            onClick={() => toggleSkills(1)}
            className={
              closeDetailsOne === false
                ? "skills_content skills_open"
                : "skills_content skills_close"
            }
          >
            <div className="skills_header skills_frontend">
              <i className="uil uil-brackets-curly skills_icon"></i>
              <div>
                <h1 className="skills_title">Frontend Developer</h1>
                <span className="skills_subtitle">3.5 years of experience</span>
              </div>
              <i className="uil uil-angle-down skills_arrow"></i>
            </div>
            <div className="skills_list grid">
              {/* dynamic content */}
              {frontend_Skills.map((skill, idx) => {
                return <Skill skill={skill} key={idx} />;
              })}
            </div>
          </div>

          <div
            onClick={() => toggleSkills(2)}
            className={
              closeDetailsTwo === true
                ? "skills_content skills_open"
                : "skills_content skills_close"
            }
          >
            <div className="skills_header skills_backend">
              <i className="uil uil-server-network-alt skills_icon"></i>
              <div>
                <h1 className="skills_title">Backend Developer</h1>
                <span className="skills_subtitle">1 year of experience</span>
              </div>
              <i className="uil uil-angle-down skills_arrow"></i>
            </div>
            <div className="skills_list grid">
              {/* dynamic content */}
              {backend_Skills.map((skill, idx) => {
                return <Skill skill={skill} key={idx} />;
              })}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default SkillsUpdatedUi;
